import React, { useMemo } from 'react'
import { WebsiteComponentsIntlProvider } from '@grammarly/website-components'
import { loadTranslations } from './utils/loadMessages'
import { useLanguage, useLocalization } from '@lib/hooks'

interface CmsI18nProviderProps {
  children: React.ReactNode
}

export const CmsI18nProvider: React.FC<CmsI18nProviderProps> = ({ children }) => {
  const { locale } = useLocalization()
  const { lang } = useLanguage()

  const translations = useMemo(() => loadTranslations(lang), [lang])

  return (
    <WebsiteComponentsIntlProvider locale={locale} i18nDictionary={translations.websiteComponents}>
      {/* Nest other translation providers here */}
      {children}
    </WebsiteComponentsIntlProvider>
  )
}
